import type { ILayerView } from "../model/Layer";

export default class SalesforceSyncUtil {
    /**
     * 
     * @param isFullSync 
     * @param geoMapId 
     * @param callbackForTasks 
     * @param context 
     */
    prepareSyncTask(isFullSync: boolean, geoMapId: number, callbackForTasks: Function, context?: any) {
        es.api.geoMap.get(geoMapId).then((geoMap) => {
            return (geoMap.$type == "TerritoryTempGeoMap" // TODO FIXME can't we sync on master copy?!
                ? es.api.territory.getTerritoryMetaByGeoMapId(geoMapId).then((territoryMeta) => {
                    return (territoryMeta?.sfProps?.customObject ? geoMap : es.util.deferred.resolved());
                })
                : es.util.deferred.resolved());
        }).then((territoryGeoMap) => {
            return es.api.layerView.getByGeoMapExcludeAnalysis(geoMapId).then((layerViews) => {
                const taskContainer = [];
                _.each(layerViews, (layerView) => {
                    if (layerView.importMeta) {
                        taskContainer.push({
                            meta: {
                                title: layerView.title,
                                layerViewId: layerView.id
                            },
                            taskType: "SALESFORCE_SYNC"
                        });
                    }
                });

                if (territoryGeoMap) {
                    taskContainer.push({
                        meta: {
                            title: territoryGeoMap.title,
                            geoMapId: territoryGeoMap.id
                        },
                        taskType: "TERRITORY_SALESFORCE_IMPORT"
                    });
                }

                return taskContainer;
            });
        }).then((taskContainer) => {
            es.api.integrationSalesforce.syncDatasetByGeoMapId(geoMapId, isFullSync).then((asyncTasks) => {
                if (asyncTasks.length > 0) {
                    for (let i = 0; i < taskContainer.length; i++) {
                        asyncTasks[i].meta = taskContainer[i].meta;
                        asyncTasks[i].taskType = taskContainer[i].taskType;
                        asyncTasks[i].percentage = 0;
                    }
                }

                if (context) {
                    callbackForTasks.call(context, asyncTasks);
                } else {
                    callbackForTasks(asyncTasks);
                }
            });
        });
    }

    /**
     * 
     * @param layerViews Array or backbone Collection?
     * @param map 
     * @param callbackForUpdate 
     * @param context 
     */
    checkAndDoAutomaticSync(layerViews: ILayerView[], map, callbackForUpdate: Function, context: any) {
        Promise.all([
            es.api.layerMeta.getByGeoMap(map.meta.getId()),
            es.api.asyncTasks.getForGeoMap(map.meta.getId())
        ]).then(([layerMetasWithAccess, asyncTasks]) => {
            const anySalesforceLayerToSyncAutomatically = layerViews.find((item, position) => {
                const layerMetaId = map.layer.getById(item.id).getLayerMetaId();
                if (!layerMetaId) {
                    return false;
                }

                const layerMeta = layerMetasWithAccess.find(lm => lm.id == layerMetaId);
                return (es.util.salesforce.isSfImportMeta(layerMeta) && layerMeta.importMeta.lastSync === 0 && !asyncTasks.find((task) => {
                    return task.meta && task.meta.importActionType === 'UPSERT' && task.meta.layerMetaId == layerMetaId;
                }));
            });

            if (anySalesforceLayerToSyncAutomatically) {
                es.api.getEventChannel().addOnce("onSyncDatasetFinish", () => {
                    es.api.layerInfo.getForLayerView(anySalesforceLayerToSyncAutomatically.id).done((layerInfo) => {
                        if (!es.util.bounds.isEmpty(layerInfo.featureInfo.bounds)) {
                            map.baseMap.setBounds(layerInfo.featureInfo.bounds);
                        }
                    });
                });

                callbackForUpdate.call(context);
            }
        });
    }

    /**
     * 
     * @param map 
     * @param isNoCache 
     * 
     * @returns 
     */
    getLastUpdate(map, isNoCache?: boolean): JQueryDeferred<any> {
        return $.when(
            es.api.layerView.getByGeoMapExcludeAnalysis(map.meta.getId(), isNoCache === true ? {noCache: true} : null),
            es.api.tenant.getTenantConfig()
        ).then((layerViews, tenantConfig) => {
            const lastUpdateInfo = {};

            let oldestDate = Date.now();
            let newestDate = 0;
            lastUpdateInfo.salesforceDatasets = false;
            _.each(layerViews, (layerView) => {
                if(es.util.salesforce.isSfImportMeta(layerView.importMeta)) {
                    lastUpdateInfo.salesforceDatasets = true;
                    const lastModified = layerView.importMeta.lastSync;
                    oldestDate = oldestDate > lastModified ? lastModified : oldestDate;
                    newestDate = newestDate < lastModified ? lastModified : newestDate;
                }
            });

            lastUpdateInfo.lastSync = newestDate;
            lastUpdateInfo.missingLastDate = !!newestDate;
            lastUpdateInfo.howLongSinceUpdate = Math.floor((Date.now() - newestDate) / 1000); // howLongSinceUpdate is in seconds e.g. if howLongSinceUpdate < 60 then display "a few seconds ago"

            lastUpdateInfo.isLastSyncOverThreshold = false;
            lastUpdateInfo.autoSyncPeriod = tenantConfig.autoSyncPeriod;
            if(tenantConfig.autoSyncPeriod > -1){ // -1 indicates tenant wants to disable auto sync
                const oldestSyncAge = Math.floor((Date.now() - oldestDate) / 1000);
                lastUpdateInfo.isLastSyncOverThreshold = (oldestSyncAge > (tenantConfig.autoSyncPeriod * 60 * 60) ); // convert autoSyncPeriod which is in hours to seconds
            }

            lastUpdateInfo.oldestDate = oldestDate;
            //console.log("getLastUpdate", oldestDate, new Date(oldestDate));
            
            return es.util.deferred.resolved(lastUpdateInfo);
        });
    }
}
